exports.ImageUploader = {
  path: '/imageuploader',
  name: 'ImageUploader'
}
